import React from "react";
import styled from "styled-components";
import {
  AW_PLAYER_A,
  AW_PLAYER_B,
  AW_BOTH_PLAYERS,
  AW_REMOVE,
} from "../../../utils/constants";

const AdminMatchPanel = ({
  playerAaw,
  playerBaw,
  playerA,
  playerB,
  matchStatus,
  onAWOption,
  onMarkReviewed,
  onDeleteResults,
}) => {
  return (
    <Section>
      <SectionHeader>ADMIN</SectionHeader>
      <AdminBlock>
        <AdminBlockLabel>Estado de la partida</AdminBlockLabel>
        <AdminStatusText>Actual: {matchStatus}</AdminStatusText>
        <AdminBtn onClick={onMarkReviewed}>
          Marcar como REVISADO
        </AdminBtn>
        <AdminHint>
          El estado REVISADO supone que el admin ha realizado una revisión y
          está toda la información de la partida bien cubierta. Desde ese
          momento la partida ya no podrá ser editada por los jugadores y en
          caso de error solo un admin podrá modificarla.
        </AdminHint>
      </AdminBlock>
      <AdminBlock>
        <AdminBlockLabel>Admin Wins</AdminBlockLabel>
        <AwGrid>
          <AwPill
            $active={playerAaw === "AW"}
            onClick={() => onAWOption(AW_PLAYER_A)}
          >
            AW para {playerA?.username}
          </AwPill>
          <AwPill
            $active={playerBaw === "AW"}
            onClick={() => onAWOption(AW_PLAYER_B)}
          >
            AW para {playerB?.username}
          </AwPill>
          <AwPill
            $active={playerAaw === "AL" && playerBaw === "AL"}
            onClick={() => onAWOption(AW_BOTH_PLAYERS)}
          >
            AL ambos jugadores
          </AwPill>
          <AwPill $danger onClick={() => onAWOption(AW_REMOVE)}>
            Borrar AWs
          </AwPill>
          <AwPill $danger onClick={onDeleteResults}>
            Borrar resultado
          </AwPill>
        </AwGrid>
      </AdminBlock>
    </Section>
  );
};

const Section = styled.div`
  background: var(--v-surface);
  border: 1px solid rgba(82, 0, 255, 0.2);
  border-radius: 20px;
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const SectionHeader = styled.h4`
  font-family: var(--v-font-mono);
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: var(--v-mint);
  margin: 0;
`;

const AdminBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const AdminBlockLabel = styled.h5`
  font-family: var(--v-font-mono);
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--v-uv);
  margin: 0;
`;

const AdminStatusText = styled.p`
  font-family: var(--v-font-body);
  font-size: 12px;
  color: var(--v-fg-muted);
  margin: 0;
`;

const AdminHint = styled.i`
  font-family: var(--v-font-body);
  font-size: 11px;
  color: var(--v-fg-muted);
  line-height: 1.4;
`;

const AdminBtn = styled.button`
  background: transparent;
  border: 1px solid var(--v-mint);
  color: var(--v-mint);
  font-family: var(--v-font-mono);
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 0.45rem 1rem;
  border-radius: 24px;
  cursor: pointer;
  transition: background var(--v-transition);

  &:hover {
    background: var(--v-mint);
    color: #000;
  }
`;

const AwGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`;

const AwPill = styled.div`
  padding: 0.45rem 0.75rem;
  border: 1px solid
    ${({ $danger }) =>
      $danger ? "rgba(255,75,75,0.2)" : "rgba(255,255,255,0.08)"};
  border-radius: 12px;
  font-family: var(--v-font-mono);
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: ${({ $active, $danger }) =>
    $active ? "#000" : $danger ? "#ff4b4b" : "var(--v-fg-muted)"};
  background: ${({ $active }) => ($active ? "var(--v-mint)" : "transparent")};
  cursor: pointer;
  transition: background var(--v-transition);

  &:hover {
    background: ${({ $active, $danger }) =>
      $active
        ? "var(--v-mint)"
        : $danger
        ? "rgba(255,75,75,0.1)"
        : "rgba(255,255,255,0.04)"};
  }
`;

export default AdminMatchPanel;
